module.exports = __webpack_public_path__ + "img/p1.0e73bd71.png";